import React, { useState, useEffect, useMemo, useRef } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import TabelaLoading from '../../../components/TabelaLoading';
import TabelaVazia from '../../../components/TabelaVazia';
import { FaFileInvoice, FaUsers, FaPen, FaPlus, FaSearch, FaThumbsUp, FaThumbsDown, FaUpload, FaList, FaTable, FaBackward, FaEye, FaEllipsisV, FaTimes, FaCheck, FaUserEdit, FaUndo, FaSignature, FaCalendarAlt, FaFilter, FaPlane, FaPlaneDeparture } from 'react-icons/fa';
import { RiMailSendLine } from 'react-icons/ri';
import { ImCancelCircle } from 'react-icons/im';
import IconButton from '../../../components/IconButton';
import api from '../../../services/api';
import Alert from '../../../components/Alert';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useLocation, useHistory, Link } from 'react-router-dom';
import ReactSelect from '../../../components/ReactSelect';
import ParticipantesConfirmados from '../../../components/ParticipantesConfirmados';
import ModalForcarEnvio from '../../../components/ModalForcarEnvio';
import { useCartaFila, CardCartaFila, BadgeCartaFila, PERFIS_FILA } from '../../../components/CartaFilaStatus';
import { data, dataHora, temRamoFarmaceutico, temRamoNaoFarmaceutico, CATEGORIA_NAO_FARMACEUTICO } from '../../../util/util';
import { FinField, FinInput } from '../../../components/FinField';
import { usePermissoes } from '../../../context/PermissoesContext';
import '../../../css/financeiro-parcela-pagar.css';

// Etapas do fluxo do convidado que podem ser reabertas (zera a data de conclusão no backend).
// As chaves batem com o mapa COLUNAS_RESET_ETAPA do ParticipanteController.
const ETAPAS_RESET = [
    { key: 'carta', label: 'Assinatura de Carta' },
    { key: 'dados', label: 'Confirmação de Dados' },
    { key: 'aereo', label: 'Aéreo' },
    { key: 'hotel', label: 'Hotel' },
    { key: 'transfer', label: 'Transfer' },
];

// origemregistro só é gravado como 'evento' pela tela de inclusão no local; todo o resto (importação,
// cadastro manual do RSVP, fluxo do convite) fica no default 'excel' do banco. Por isso o oposto de
// "incluído no local" é "cadastro prévio", e não "veio da planilha" — que seria mentira.
const ORIGEM_LOCAL = 'evento';
const OPCOES_ORIGEM = [
    { value: 'todos', label: 'Todas' },
    { value: 'local', label: 'Incluso no local' },
    { value: 'previo', label: 'Cadastro prévio' },
];
const OPCOES_ASSINADO = [
    { value: 'todos', label: 'Todos' },
    { value: 'sim', label: 'Assinou' },
    { value: 'nao', label: 'Não assinou' },
];
// Tamanho de página inicial e ordenação inicial da tela.
const PAGE_SIZE_DEFAULT = 50;
const ORDEM_INICIAL = { campo: null, dir: 'asc' };

const ehIncluidoNoLocal = (row) => (row?.origemregistro ?? '') === ORIGEM_LOCAL;
const assinouLista = (row) => !!row?.datalista?.imagemassinatura;

const normalizarDataLista = (valor) => {
    if (!valor || (typeof valor === 'string' && valor.trim() === '')) {
        return null;
    }

    if (typeof valor === 'string' && valor.startsWith('0000-00-00')) {
        return null;
    }

    let dataMoment = moment(valor, 'DD/MM/YYYY', true);
    if (!dataMoment.isValid()) {
        dataMoment = moment(valor);
    }

    if (!dataMoment.isValid() || dataMoment.year() < 1900) {
        return null;
    }

    return dataMoment.format('DD/MM/YYYY');
};

export default function PainelEventoParticipante({ match }) {
    let { search, state } = useLocation();
    const params = new URLSearchParams(search);
    const id = match.params.id;
    const token = localStorage.getItem('token');

    // Modal de envio imediato: aberto quando o back recusa por a carta ja estar na fila.
    const [forcarEnvio, setForcarEnvio] = useState({ show: false, mensagem: '', reenviar: null });
    const perfil = localStorage.getItem("perfil");
    const history = useHistory();
    const permissoes = usePermissoes();

    // Estado da fila de cartas do evento: alimenta o card do topo e as marcas nas linhas.
    // So consulta quem enxerga o card e as marcas. O back passou a exigir perfil (PERFIS_FILA),
    // entao para os demais a requisicao volta "Acesso Negado" e nao alimenta nada — era uma
    // chamada inutil por abertura de tela. Com id nulo o hook nem sai do lugar.
    const { fila, recarregarFila } = useCartaFila(PERFIS_FILA.includes(perfil) ? id : null, token);

    // Recupera os valores do localStorage
    const savedTipoListaPresenca = localStorage.getItem(`tipoListaPresenca_${id}`);
    const savedNomeTipoListaPresenca = localStorage.getItem(`nomeTipoListaPresenca_${id}`);
    const savedDataLista = normalizarDataLista(localStorage.getItem(`datalista_${id}`));
    const savedNomeDataLista = normalizarDataLista(localStorage.getItem(`nomeDatalista_${id}`));
    // Dia da lista na URL: é o que a navegação entre as telas (lista ⇄ assinatura) carrega,
    // então tem prioridade sobre o localStorage e sobre a resolução automática.
    const dataListaUrl = normalizarDataLista(params.get('datalista'));

    const [filtro, setFiltro] = useState({
        tipoListaPresenca: savedTipoListaPresenca ? parseInt(savedTipoListaPresenca) : 1,
        nomeTipoListaPresenca: savedNomeTipoListaPresenca || "Evento",
        datalista: dataListaUrl || savedDataLista || null,
        nomeDatalista: dataListaUrl || savedNomeDataLista || null,
        nome: params.get('nome') || null,
        origem: 'todos',
        assinado: 'todos',
    });
    const [diasEvento, setDiasEvento] = useState([]);
    const [showDiaListaModal, setShowDiaListaModal] = useState(false);
    const [mostrarFiltros, setMostrarFiltros] = useState(false);
    const [eventoParticipantes, setEventoParticipantes] = useState([]);
    const [evento, setEvento] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, pageSize: PAGE_SIZE_DEFAULT, total: 0 });
    const [ordem, setOrdem] = useState(ORDEM_INICIAL);
    const [contadoresStatus, setContadoresStatus] = useState([]);
    // Guarda de resposta obsoleta no molde do PainelEvento: cada busca leva um id e a resposta que
    // não for a da última é descartada.
    const buscarIdRef = useRef(0);
    // O `filtro` em vigor, para o call site assíncrono (dentro do .then do /evento) não montar a
    // busca com o filtro da closure do render em que o buscar() foi chamado.
    const filtroRef = useRef(filtro);
    filtroRef.current = filtro;
    // Filtros de Cargo e Instituição: só na lista digital (listarsvp) de evento com o ramo não farmacêutico.
    // Ficam dentro do mesmo modal de filtros que todos os perfis enxergam.
    // Faixa de colunas de identificação: CRM em evento farmacêutico, Cargo + Instituição no não
    // farmacêutico — mesmos perfis nos dois casos. O "Ambos" mostra as duas.
    const mostrarColunaCrm = temRamoFarmaceutico(evento);
    const temRamoNaoFarm = temRamoNaoFarmaceutico(evento);
    const perfisColunaIdentificacao = ['rsvp', 'listarsvp', 'gerentersvp', 'coordenadorrsvp'];
    const mostrarColunasNaoFarmaceutico = perfisColunaIdentificacao.includes(perfil) && temRamoNaoFarm;
    const temFiltrosNaoFarmaceutico = ['listarsvp'].includes(perfil) && temRamoNaoFarm;
    // Todo o modal trabalha em rascunho: nada é aplicado (nem dispara busca) antes do "Aplicar".
    const [filtrosRascunho, setFiltrosRascunho] = useState({});
    const [showActionsModal, setShowActionsModal] = useState(false);
    const [actionsModalData, setActionsModalData] = useState({ participante: null, actions: [] });
    const [selecionados, setSelecionados] = useState([]);
    const [showResetarEtapasModal, setShowResetarEtapasModal] = useState(false);
    const [resetarEtapasIds, setResetarEtapasIds] = useState('');
    const [resetarEtapasSelecao, setResetarEtapasSelecao] = useState({});
    // "Apagar dados" por etapa: só vale para etapa marcada, e o switch dela só aparece quando marcada
    const [resetarEtapasApagarDados, setResetarEtapasApagarDados] = useState({});
    const [resetarEtapasSubmitting, setResetarEtapasSubmitting] = useState(false);
    const operador = state?.operador ?? null;
    const ehListaRsvp = ['listarsvp'].includes(perfil);

    // Definições das colunas nomeáveis do evento. NÃO saem do `evento` desta tela: ele vem do
    // index (`GET /evento?id=`), que não appenda `colunas` — só o `show` e o
    // `listaPresencaResumo` fazem isso. Lendo de lá, a grade do listarsvp ficava sem coluna.
    const [colunasDoEvento, setColunasDoEvento] = useState([]);

    useEffect(() => {
        if (!ehListaRsvp || !id) {
            return;
        }
        api({
            method: 'get',
            action: '/evento/listaPresencaResumo/' + id,
            token: token,
        })
            .then(response => {
                setColunasDoEvento(response.data?.data?.colunas ?? []);
            })
            .catch(() => {
                // sem as definições a grade sai sem as colunas, como antes — não derruba a tela
            });
        // eslint-disable-next-line
    }, [ehListaRsvp, id]);
    // Perfis que enxergam a lista de presença (mesma regra que já valia para o "Assinado" das ações)
    const vePresenca = ['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'listarsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil);
    const getNomeOperadorResponsavel = (row) => {
        return row?.eventooperador?.operador?.nome ?? "";
    };
    // o vínculo agora sobrevive à mudança de status, então a coluna precisa dizer se aquele
    // operador ainda está com o atendimento em aberto ou se já concluiu
    const getAtendimentoOperador = (row) => {
        if (!row?.eventooperador?.operador?.nome) {
            return null;
        }
        if (row.eventooperador.feito === 'sim') {
            return 'Concluído';
        }
        // reaberto é diferente de nunca atendido: quem gerencia precisa ver que alguém
        // desfez uma conclusão, e não só que o atendimento está em aberto
        return row.eventooperador.datareabertura ? 'Reaberto' : 'Pendente';
    };
    const getEstiloAtendimento = (atendimento) => {
        if (atendimento === 'Concluído') {
            return 'is-ok';
        }
        return atendimento === 'Reaberto' ? 'is-warn' : 'is-muted';
    };
    const estiloBotaoDestaqueAcoes = {
        backgroundColor: '#eaf2ff',
        borderColor: '#b8cdf5',
        color: '#24467f',
    };

    useEffect(() => {
        if (!savedDataLista) {
            localStorage.removeItem(`datalista_${id}`);
            localStorage.removeItem(`nomeDatalista_${id}`);
        }
    }, [id, savedDataLista]);

    // Dia veio na URL: espelha no localStorage, que é o que as telas sem a query (ex.: cadastro de
    // novo participante → assinatura) leem. URL manda; localStorage só segue.
    useEffect(() => {
        if (dataListaUrl) {
            localStorage.setItem(`datalista_${id}`, dataListaUrl);
            localStorage.setItem(`nomeDatalista_${id}`, dataListaUrl);
        }
    }, [id, dataListaUrl]);

    // Grava o dia escolhido para a lista: filtro + localStorage (fallback da tela de assinatura)
    const aplicarDataLista = (novaData) => {
        if (!novaData) {
            return;
        }
        localStorage.setItem(`datalista_${id}`, novaData);
        localStorage.setItem(`nomeDatalista_${id}`, novaData);
        setFiltro((valorAtual) => ({ ...valorAtual, datalista: novaData, nomeDatalista: novaData }));
    };

    // listarsvp: o dia da lista passa a ser o dia de hoje sempre que hoje for um dos dias do evento
    // (senão a tela abre no dia herdado da sessão anterior). Quando hoje não é dia de evento e ainda
    // não há dia escolhido, pergunta qual dia usar logo no primeiro acesso à listagem.
    useEffect(() => {
        if (!['listarsvp'].includes(perfil) || dataListaUrl) {
            return;
        }

        api({
            method: 'get',
            action: '/evento/datas/' + id,
            token: token,
        })
            .then(response => {
                const dias = response.data.data ?? [];
                const hoje = moment().format('DD/MM/YYYY');

                if (dias.includes(hoje)) {
                    aplicarDataLista(hoje);
                    return;
                }

                if (savedDataLista) { //já escolheu antes: mantém o dia da escolha
                    return;
                }

                if (dias.length > 1) {
                    setDiasEvento(dias);
                    setShowDiaListaModal(true);
                }
            }).catch(err => {
                //console.log(err)
            });
    },
        // eslint-disable-next-line
        []);

    // Mantém o dia escolhido na URL para a navegação lista ⇄ assinatura preservar a seleção
    useEffect(() => {
        if (!filtro.datalista || params.get('datalista') === filtro.datalista) {
            return;
        }
        const novaBusca = new URLSearchParams(search);
        novaBusca.set('datalista', filtro.datalista);
        history.replace({ search: '?' + novaBusca.toString(), state: state });
    },
        // eslint-disable-next-line
        [filtro.datalista]);

    // `pedirTotais`: governa só os CONTADORES por status, que o servidor calcula ignorando o filtro
    // de situação (eles são a interface de seleção do filtro) — trocar de página, de tamanho, de
    // ordenação ou de chip não muda nenhum deles, então nesses casos o GROUP BY é dispensado.
    // O total da paginação é outra coisa: muda com o filtro e vem sempre, como no EventoController.
    const carregarParticipantes = ({
        page = pagination.page,
        pageSize = pagination.pageSize,
        ordemAtual = ordem,
        pedirTotais = true,
        override,
    } = {}) => {
        // `override` para quem muda o filtro e busca no MESMO clique (o chip de status): o setFiltro
        // é assíncrono, então sem ele a busca sairia com o filtro anterior. Idioma do PainelSla.
        const filtroEmVigor = override ? { ...filtroRef.current, ...override } : filtroRef.current;
        const dataListaSelecionada = normalizarDataLista(filtroEmVigor.datalista);
        const buscarId = ++buscarIdRef.current;
        setSelecionados([]);
        let buscarParticipantes = true;

        // a lista digital não busca "tudo" por padrão; qualquer filtro serve de gatilho — os de
        // identificação (nome/cargo/empresa) e os de linha (origem/lista de presença, ex.: "não
        // assinou" no fim do dia). Sem contar todos aqui, filtrar por um deles não traria resultado.
        const temBuscaIdentificacao = (filtroEmVigor.nome ?? "") !== ""
            || !!filtroEmVigor.cargoparticipante
            || (filtroEmVigor.instituicao ?? "") !== "";
        const temFiltroDeLinha = (filtroEmVigor.origem ?? 'todos') !== 'todos' || (filtroEmVigor.assinado ?? 'todos') !== 'todos';

        if (['listarsvp'].includes(perfil) && !temBuscaIdentificacao && !temFiltroDeLinha) {
            buscarParticipantes = false;
        }

        if (!buscarParticipantes) {
            setEventoParticipantes([]);
            setPagination((atual) => ({ ...atual, page: 1, total: 0 }));
            setContadoresStatus([]);
            setFiltro((valorAtual) => ({ ...valorAtual, buscando: false }));
            return;
        }

        // O loading da tabela é desta busca, não da do evento: trocar de página, ordenar ou clicar
        // num contador tem que mostrar o mesmo carregando que o "Aplicar filtros" mostra.
        setFiltro((valorAtual) => ({ ...valorAtual, buscando: true }));

        api({
            method: 'get',
            action: '/participante',
            token: token,
            params: {
                ...filtroEmVigor,
                ...{
                    evento: id,
                    tipoCadastro: "participante",
                    // relações que esta tela lê (o endpoint só carrega o que for declarado)
                    operador: operador,
                    page,
                    pageSize,
                    ordenarPor: ordemAtual.campo,
                    ordenarDir: ordemAtual.dir,
                    // os contadores só aparecem fora do listarsvp — não pede a conta que não usa
                    comTotaisSituacaoEvento: !ehListaRsvp && pedirTotais,
                    // Relações declaradas (`include`): o default do endpoint é só enderecomunicipio
                    // e evento, então o que esta tela mostra tem que ser pedido. `colunasvalores`
                    // traz os valores das colunas nomeáveis em lote — sem ele o back não appenda
                    // `colunas` e a grade do perfil listarsvp fica sem as colunas do evento.
                    include: 'enderecomunicipio,evento,situacaoevento' + (ehListaRsvp ? ',colunasvalores' : ''),
                    // listarsvp não exibe operador responsável nem histórico: não carrega o que não mostra
                    carregarOperadorResponsavel: !ehListaRsvp,
                    ultimoHistorico: !ehListaRsvp,
                    semHistorico: ehListaRsvp,
                    ...(dataListaSelecionada ? { datalista: dataListaSelecionada } : {}),
                }
            }
        })
            .then(response => {
                if (buscarId !== buscarIdRef.current) return; // resposta de busca antiga, ignora
                setEventoParticipantes(response.data.data);
                // O servidor clampa a página e capa o tamanho: a tela adota os valores efetivos que
                // ele devolveu, senão a numeração daqui discorda da dele e esconde registros.
                setPagination({
                    page: response.data.page ?? page,
                    pageSize: response.data.pageSize ?? pageSize,
                    total: response.data.total ?? response.data.data.length,
                });
                if (!ehListaRsvp && pedirTotais) {
                    setContadoresStatus(response.data.totaisSituacaoEvento ?? []);
                }
                setFiltro((valorAtual) => ({ ...valorAtual, buscando: false }));
            }).catch(err => {
                if (buscarId !== buscarIdRef.current) return;
                setFiltro((valorAtual) => ({ ...valorAtual, buscando: false }));
                //console.log(err)
            });
    };

    const buscar = () => {
        setFiltro((valorAtual) => ({ ...valorAtual, buscando: true }));
        const precisaResolverDataLista = filtro.datalista === undefined || filtro.datalista === null;

        api({
            method: 'get',
            action: '/evento',
            token: token,
            params: {
                ...{ id: id }
            }
        })
            .then(response => {
                var evento = response.data.data[0];
                const dataListaPadrao = normalizarDataLista(evento.dataLista) || normalizarDataLista(evento.data);

                if (precisaResolverDataLista) {
                    setEvento(evento);
                    // não sobrescreve o dia que a resolução automática (listarsvp) já tenha aplicado
                    setFiltro((valorAtual) => ({
                        ...valorAtual,
                        datalista: valorAtual.datalista ?? dataListaPadrao,
                        nomeDatalista: valorAtual.nomeDatalista ?? dataListaPadrao,
                    }));

                    if (!dataListaPadrao) {
                        // page 1 explícito: buscar da página 4 com um resultado de 2 registros
                        // devolveria tabela vazia e rodapé "4 / 1".
                        carregarParticipantes({ page: 1 });
                    }

                    return;
                }

                setEvento(evento);
            }).catch(err => {
                //console.log(err)
            });

        if (!precisaResolverDataLista) {
            // page 1 explícito, mesmo motivo do call site acima.
            carregarParticipantes({ page: 1 });
        }
    };

    useEffect(() => {
        buscar();
    },
        // todos os filtros do modal são server-side: aplicar qualquer um refaz a busca sozinho
        // eslint-disable-next-line
        [filtro.datalista, filtro.tipoListaPresenca, filtro.cargoparticipante, filtro.instituicao,
        filtro.origem, filtro.assinado, filtro.situacaocartaconvite, filtro.situacaocartainformativa]);

    // Colunas nomeáveis: só para perfil listarsvp, e só as marcadas para questionar e não travadas
    // no cadeado. A lista vem normalizada do evento (`colunas`), sem 1..10 fixo — a 11ª em diante
    // entra sozinha. O valor da linha sai de `participante.colunas`, casado pela ordem.
    const colunasNomeaveis = useMemo(() => {
        if (!['listarsvp'].includes(perfil) || !evento || !evento.id) return [];
        const valorDaLinha = (row, ordem) => (
            ((row.colunas ?? []).find(coluna => coluna.ordem === ordem) ?? {}).valor ?? ''
        );
        return colunasDoEvento
            .filter(coluna => coluna.questionar && coluna.ativo)
            .map(coluna => ({
                name: coluna.nome,
                selector: row => valorDaLinha(row, coluna.ordem),
                sortable: true,
                width: '120px',
                cell: row => valorDaLinha(row, coluna.ordem),
            }));
    }, [perfil, evento, colunasDoEvento]);

    // Clique no contador filtra por aquele status; clicar no mesmo de novo (ou no "Limpar status")
    // desfaz. É filtro à parte dos do drawer — não substitui nem é substituído por eles.
    const aplicarStatus = (proximo) => {
        setFiltro((valorAtual) => ({ ...valorAtual, situacaoevento: proximo }));
        carregarParticipantes({ page: 1, pedirTotais: false, override: { situacaoevento: proximo } });
    };

    const filtrarPorStatus = (idSituacao) => {
        aplicarStatus(String(filtro.situacaoevento ?? '') === String(idSituacao) ? '' : String(idSituacao));
    };

    const limparFiltroStatus = () => aplicarStatus('');

    // Ordenar é pedido ao servidor: ordenar só a página traria a ordem errada assim que houver
    // mais de uma. Trocar o campo (ou a direção) volta para a 1ª página.
    const ordenarPor = (campo) => {
        const proxima = ordem.campo === campo
            ? { campo, dir: ordem.dir === 'asc' ? 'desc' : 'asc' }
            : { campo, dir: 'asc' };
        setOrdem(proxima);
        carregarParticipantes({ page: 1, pedirTotais: false, ordemAtual: proxima });
    };

    // Conta o que está APLICADO (não o rascunho) — junta os filtros dos dois grupos do modal
    const filtrosAplicados = [
        (filtro.origem ?? 'todos') !== 'todos',
        (filtro.assinado ?? 'todos') !== 'todos',
        !!filtro.situacaocartaconvite,
        !!filtro.situacaocartainformativa,
        !!filtro.cargoparticipante,
        !!filtro.situacaoevento,
        (filtro.instituicao ?? '') !== '',
    ].filter(Boolean).length;

    // Abre o modal com o rascunho espelhando o filtro em uso
    const abrirFiltros = () => {
        setFiltrosRascunho({
            cargoparticipante: filtro.cargoparticipante ?? '',
            nomeCargoparticipante: filtro.nomeCargoparticipante ?? '',
            instituicao: filtro.instituicao ?? '',
            origem: filtro.origem ?? 'todos',
            assinado: filtro.assinado ?? 'todos',
            situacaocartaconvite: filtro.situacaocartaconvite ?? '',
            nomeSituacaocartaconvite: filtro.nomeSituacaocartaconvite ?? 'Todas',
            situacaocartainformativa: filtro.situacaocartainformativa ?? '',
            nomeSituacaocartainformativa: filtro.nomeSituacaocartainformativa ?? 'Todas',
        });
        setMostrarFiltros(true);
    };

    // Um "Aplicar" só: grava tudo de uma vez e a busca dispara pelo useEffect que observa esses campos.
    // Vazio vai como undefined para bater com o estado inicial — trocar '' por undefined refaria a busca à toa.
    const aplicarFiltros = () => {
        setFiltro((atual) => ({
            ...atual,
            origem: filtrosRascunho.origem ?? 'todos',
            assinado: filtrosRascunho.assinado ?? 'todos',
            situacaocartaconvite: filtrosRascunho.situacaocartaconvite || undefined,
            nomeSituacaocartaconvite: filtrosRascunho.nomeSituacaocartaconvite || undefined,
            situacaocartainformativa: filtrosRascunho.situacaocartainformativa || undefined,
            nomeSituacaocartainformativa: filtrosRascunho.nomeSituacaocartainformativa || undefined,
            ...(temFiltrosNaoFarmaceutico ? {
                cargoparticipante: filtrosRascunho.cargoparticipante || undefined,
                nomeCargoparticipante: filtrosRascunho.nomeCargoparticipante || undefined,
                instituicao: filtrosRascunho.instituicao || undefined,
            } : {}),
        }));
        setMostrarFiltros(false);
    };

    // A página já vem pronta e ordenada do servidor. O `participantesOrdenados` que existia aqui
    // ordenava só a página carregada — com a paginação no servidor isso daria a ordem errada assim
    // que houvesse mais de uma. As mesmas cinco colunas continuam ordenáveis, agora sobre o
    // resultado inteiro (`ordenarPor` -> `ordenarPor`/`ordenarDir` no /participante).
    const participantesPagina = eventoParticipantes;

    const totalPaginas = Math.max(1, Math.ceil(pagination.total / pagination.pageSize));

    // Monta as ações de uma linha para o action-sheet (padrão fin-pp)
    // Handlers de envio/exclusão por participante (idParticipantes = id da linha)
    /**
     * Dispara o convite. Um id só sai na hora; vários vão para a fila — quem decide é o
     * back, pela quantidade.
     *
     * Quando o back recusa por já haver carta enfileirada para aquela pessoa, ele devolve
     * `podeForcar` e a tela oferece o modal de envio imediato, em vez de deixar o operador
     * sem saída a não ser esperar.
     */
    const enviarConviteRequest = (ids, forcar) => {
        api({
            method: 'post',
            action: '/eventoCarta/enviarCartaConvite',
            token: token,
            data: { idParticipantes: ids, forcarEnvio: forcar },
        })
            .then(function (response) {
                const dados = response.data.data;

                // Recusa do back (token expirado) vem 200 com `mensagem` e nada mais: sem isto
                // nenhum contador existe, `erros` fica vazio e o clique nao produz reacao
                // nenhuma na tela — que e exatamente o estado que faz o operador clicar de novo.
                if (dados.quantidadeSucesso === undefined && dados.mensagem) {
                    toast.error(dados.mensagem);
                    return;
                }

                if (dados.podeForcar) {
                    setForcarEnvio({ show: true, mensagem: dados.mensagem, reenviar: () => enviarConviteRequest(ids, true) });
                    return;
                }

                // Em massa o texto fala de fila; individual fala do envio. Os dois vêm do
                // back para não existirem duas versões da mesma explicação.
                if (dados.quantidadeSucesso > 0 || dados.enfileirados > 0 || dados.jaNaFila > 0) {
                    toast.success(dados.mensagem);
                }
                (dados.erros ?? []).forEach(function (erro) { toast.error(erro.mensagem); });
                buscar();
                recarregarFila(); // a carta acabou de entrar na fila: atualiza card e marcas
            })
            .catch(function () { toast.error('Carta não enviada, tente novamente.'); });
    };

    const enviarCartaConvite = (ids) => {
        Alert({
            icon: "question",
            confirmButton: <><FaThumbsUp size={20} /> Enviar</>,
            denyButton: <><FaThumbsDown size={20} /> Sair</>,
            title: "Enviar Carta Convite?",
            callBack: (result) => {
                if (result.isConfirmed) {
                    enviarConviteRequest(ids, false);
                }
            }
        });
    };

    const enviarCertificadoRequest = (ids, forcar) => {
        api({ method: 'post', action: '/eventoCarta/enviarCertificado', token: token, data: { idParticipantes: ids, forcarEnvio: forcar } })
            .then(function (response) {
                const dados = response.data.data;

                // Já havia certificado na fila para esta pessoa: oferece o envio imediato,
                // como no convite, em vez de deixar o operador só esperando.
                // Recusa do back (token expirado) vem 200 com `mensagem` e nada mais: sem isto
                // nenhum contador existe, `erros` fica vazio e o clique nao produz reacao
                // nenhuma na tela — que e exatamente o estado que faz o operador clicar de novo.
                if (dados.quantidadeSucesso === undefined && dados.mensagem) {
                    toast.error(dados.mensagem);
                    return;
                }

                if (dados.podeForcar) {
                    setForcarEnvio({ show: true, mensagem: dados.mensagem, reenviar: () => enviarCertificadoRequest(ids, true) });
                    return;
                }

                if (dados.quantidadeSucesso > 0 || dados.enfileirados > 0 || dados.jaNaFila > 0) {
                    toast.success(dados.mensagem);
                }
                (dados.erros ?? []).forEach(function (erro) { toast.error(erro.mensagem); });
                buscar();
                recarregarFila(); // a carta acabou de entrar na fila: atualiza card e marcas
            })
            .catch(function (error) { toast.error('Erro: ' + (error.response?.data?.error ?? " ao enviar certificados")); });
    };

    const enviarCertificado = (ids) => {
        Alert({
            icon: "question",
            confirmButton: <><FaThumbsUp size={20} /> Enviar</>,
            denyButton: <><FaThumbsDown size={20} /> Sair</>,
            title: "Enviar Certificado?",
            callBack: (result) => {
                if (result.isConfirmed) {
                    enviarCertificadoRequest(ids, false);
                }
            }
        });
    };

    const enviarInformativaRequest = (ids, forcar, confirmar = false) => {
        api({ method: 'post', action: '/eventoCarta/enviarCartaInformativa', token: token, data: { idParticipantes: ids, forcarEnvio: forcar, confirmarEnvio: confirmar } })
            .then(function (response) {
                // Ja havia informativa na fila para esta pessoa: oferece o envio imediato, como
                // no convite, em vez de deixar o operador so esperando.
                // Recusa do back (token expirado) vem 200 com `mensagem` e nada mais: sem isto
                // nenhum contador existe, `erros` fica vazio e o clique nao produz reacao
                // nenhuma na tela — que e exatamente o estado que faz o operador clicar de novo.
                if (response.data.data.quantidadeSucesso === undefined && response.data.data.mensagem) {
                    toast.error(response.data.data.mensagem);
                    return;
                }

                if (response.data.data.podeForcar) {
                    setForcarEnvio({ show: true, mensagem: response.data.data.mensagem, reenviar: () => enviarInformativaRequest(ids, true, confirmar) });
                    return;
                }
        
                if (response.data.data.quantidadeSucesso > 0 || response.data.data.enfileirados > 0 || response.data.data.jaNaFila > 0) {
                    // Entrou na fila, ainda nao saiu — o texto vem do back para nao haver duas versoes.
                    toast.success(response.data.data.mensagem);
                    buscar(); //a coluna Informativa e o que diz ao operador se ja foi enviado
                    recarregarFila(); // a carta acabou de entrar na fila: atualiza card e marcas
                }
                // Modal único, montado conforme o bloqueio que o backend devolver (dados faltantes,
                // reenvio, ou os dois): o back é fail-all, então nada saiu ainda e a confirmação
                // dispara o lote uma vez só.
                const errosIncompletos = (response.data.data.erros ?? []).filter(e => e.tipo === 'rsvp_incompleto');
                const errosReenvio = (response.data.data.erros ?? []).filter(e => e.tipo === 'reenvio');
                const outrosErros = (response.data.data.erros ?? []).filter(e => !['rsvp_incompleto', 'reenvio'].includes(e.tipo));
                if (errosIncompletos.length > 0 || errosReenvio.length > 0) {
                    const LIMITE_LISTA = 10; //lote grande nao pode virar um modal de rolagem infinita
                    //o html do Alert vai pra innerHTML: nome de participante e digitado pelo usuario
                    const esc = (valor) => String(valor ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
                    const restante = (lista) => lista.length > LIMITE_LISTA
                        ? `<p style="margin:4px 0 0;text-align:left;font-style:italic">e mais ${lista.length - LIMITE_LISTA} participante(s)</p>`
                        : '';
                    const blocos = errosIncompletos.slice(0, LIMITE_LISTA).map(e => {
                        const grupos = e.campos_faltantes ?? {};
                        const bullets = Object.keys(grupos)
                            .map(g => `<li><strong>${esc(g)}:</strong> ${(grupos[g] ?? []).map(esc).join(', ')}</li>`)
                            .join('');
                        return `<div style="margin-bottom:8px;text-align:left"><strong style="color:#333;display:block;margin-bottom:2px;text-align:center">Participante ${esc(e.participante)}:</strong><ul style="text-align:left;margin:4px 0 0;padding-left:18px">${bullets}</ul></div>`;
                    }).join('') + restante(errosIncompletos);
                    const blocosReenvio = errosReenvio.slice(0, LIMITE_LISTA)
                        .map(e => `<li><strong>${esc(e.participante)}</strong> — enviada em ${esc(e.enviadaem)}</li>`)
                        .join('');
                    const quantidade = String(ids).split(',').filter(i => i).length;
                    const alcance = quantidade === 1 ? 'ao participante selecionado' : `aos ${quantidade} participantes selecionados`;
                    // Havendo reenvio, a confirmação fala de reenvio mesmo que haja dados faltantes
                    // junto — senão o operador confirma achando que é o primeiro envio.
                    const temReenvio = errosReenvio.length > 0;
                    const soReenvio = temReenvio && errosIncompletos.length === 0;
                    const rotuloConfirmar = temReenvio ? 'Reenviar mesmo assim.' : 'Enviar mesmo assim.';
                    Alert({
                        icon: "warning",
                        title: soReenvio ? "Reenvio de Carta Informativa" : "Confirme o envio",
                        html: (errosIncompletos.length > 0
                            ? `<p style="margin:0 0 8px;text-align:left">A Carta Informativa possui dados faltantes:</p>${blocos}`
                            : '')
                            + (errosReenvio.length > 0
                                ? `<p style="margin:8px 0 4px;text-align:left">Já receberam a Carta Informativa:</p>`
                                + `<ul style="text-align:left;margin:4px 0 0;padding-left:18px">${blocosReenvio}</ul>`
                                + restante(errosReenvio)
                                : '')
                            + `<hr style="margin:12px 0" />`
                            + `<h5 style="color:#e74c3c;margin:0 0 6px;text-align:left">Atenção:</h5>`
                            + `<p style="margin:0 0 8px;text-align:left">Nenhum e-mail foi enviado ainda. Ao confirmar, a carta informativa será enviada <strong>${alcance}</strong>:</p>`,
                        input: "checkbox",
                        inputPlaceholder: rotuloConfirmar,
                        inputValidator: (value) => { if (!value) { return `Marque "${rotuloConfirmar}" para confirmar o envio.`; } },
                        confirmButton: temReenvio ? "Confirmar reenvio" : "Confirmar envio",
                        cancelButton: "Cancelar",
                        callBack: (resultadoBypass) => {
                            if (resultadoBypass.isConfirmed && resultadoBypass.value) {
                                // Volta pela propria funcao, e nao por um api() cru: a chamada solta
                                // perdia o `forcar` e nao tratava `podeForcar`, entao uma carta
                                // enfileirada por outro operador enquanto este Alert estava aberto
                                // virava toast verde de sucesso, sem o modal de envio imediato.
                                enviarInformativaRequest(ids, forcar, true);
                            }
                        },
                    });
                }
                outrosErros.forEach(function (erro) { if (erro.mensagem) { toast.error(erro.mensagem); } });
            })
            .catch(function (error) { toast.error('Erro: ' + (error.response?.data?.error ?? " ao carregar dados")); });
    };

    const enviarCartaInformativa = (ids) => {
        Alert({
            icon: "question",
            confirmButton: <><FaThumbsUp size={20} /> Enviar</>,
            denyButton: <><FaThumbsDown size={20} /> Sair</>,
            title: "Enviar Carta Informativa?",
            callBack: (result) => {
                if (result.isConfirmed) {
                    enviarInformativaRequest(ids, false);
                }
            }
        });
    };

    const excluirParticipante = (ids) => {
        Alert({
            icon: "error",
            confirmButton: "Sair",
            denyButton: <><FaThumbsUp size={20} /> Excluir</>,
            title: "Excluir",
            callBack: (result) => {
                if (result.isDenied) {
                    api({ method: 'delete', action: '/participantes', token: token, data: { idParticipantes: ids } })
                        .then(function () { buscar(); })
                        .catch(function () { });
                }
            }
        });
    };

    // Abre o modal de reset de etapas (ids = id da linha OU CSV da seleção em massa).
    const abrirModalResetarEtapas = (ids) => {
        setResetarEtapasIds(ids);
        setResetarEtapasSelecao({});
        setResetarEtapasApagarDados({});
        setResetarEtapasSubmitting(false);
        setShowResetarEtapasModal(true);
    };

    const confirmarResetarEtapas = () => {
        if (resetarEtapasSubmitting) { return; }
        const etapas = ETAPAS_RESET.map((e) => e.key).filter((k) => resetarEtapasSelecao[k]);
        if (etapas.length === 0) { return; }
        // só as etapas marcadas podem apagar dados — o back ignora chave fora de `etapas`, mas não manda
        const apagarDados = etapas.filter((k) => resetarEtapasApagarDados[k]);
        setResetarEtapasSubmitting(true);
        api({ method: 'post', action: '/participante/resetarEtapas', token: token, data: { idParticipantes: resetarEtapasIds, etapas: etapas, apagarDados: apagarDados } })
            .then(function () {
                toast.success('Etapas resetadas com sucesso');
                setShowResetarEtapasModal(false);
                buscar();
            })
            .catch(function (error) { toast.error('Erro: ' + (error.response?.data?.error ?? ' ao resetar etapas')); })
            .finally(function () { setResetarEtapasSubmitting(false); });
    };

    // Link direto para a tela de assinatura, levando o dia/tipo da lista em uso (listarsvp assina
    // pelo ícone da própria linha, sem passar pelo drawer)
    const linkAssinatura = (row) => ({
        pathname: "/cadastroEventoParticipanteAssinatura/" + row.id,
        search: '?' + new URLSearchParams({
            evento: id,
            datalista: filtro.datalista ?? "",
            tipoListaPresenca: filtro.tipoListaPresenca ?? "",
        }).toString(),
    });

    // Monta TODAS as ações de um participante para o drawer (idêntico ao de Eventos)
    const construirAcoesParticipante = (row) => {
        const acoes = [];
        const ids = String(row.id);
        // A constante, e nao uma copia: o docblock de PERFIS_FILA promete um ponto unico, e
        // esta lista era a quarta copia literal — mudar la e esquecer aqui esconderia as acoes
        // de envio para um perfil que a rota, o card e o back ja teriam liberado.
        const perfisCarta = PERFIS_FILA;
        const perfisExcluir = ['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'];
        const perfisResetarEtapas = ['admin', 'gerentersvp', 'coordenadorrsvp'];
        const urlVisualizar = process.env.REACT_APP_API_URL + "/eventoCarta/visualizarCarta";

        if (!['cliente', 'listarsvp', 'operadorrsvp'].includes(perfil)) {
            acoes.push({ grupo: 'Cadastro', label: 'Alterar', icon: <FaPen size={16} />, to: { pathname: "/cadastroEventoParticipante/" + row.id, state: { evento: id } } });
        }
        // Lista de presença não é ação: virou coluna na linha (e o ícone de assinar, para o listarsvp)
        if (['operadorrsvp'].includes(perfil)) {
            acoes.push({ grupo: 'Cadastro', label: 'Alterar', icon: <FaUserEdit size={16} />, to: { pathname: "/cadastroEventoParticipanteOperador/", search: new URLSearchParams({ idCliente: row.id, nomeCliente: row.nome }).toString() } });
        }

        if (perfisCarta.includes(perfil)) {
            acoes.push({ grupo: 'Carta Convite', label: 'Visualizar E-mail Convite', icon: <FaEye size={16} />, form: { method: 'post', action: urlVisualizar, data: { token: token, tipoCarta: "modeloemailconvite", idParticipantes: ids, formato: "html" } } });
            acoes.push({ grupo: 'Carta Convite', label: 'Visualizar Carta Convite', icon: <FaEye size={16} />, form: { method: 'post', action: urlVisualizar, data: { token: token, tipoCarta: "modelocartaconvite", idParticipantes: ids } } });
            acoes.push({ grupo: 'Carta Convite', label: 'Enviar Convite', icon: <RiMailSendLine size={16} />, action: () => enviarCartaConvite(ids) });

            acoes.push({ grupo: 'Certificado', label: 'Visualizar Certificado', icon: <FaEye size={16} />, form: { method: 'post', action: urlVisualizar, data: { token: token, tipoCarta: "modelocertificado", idParticipantes: ids } } });
            acoes.push({ grupo: 'Certificado', label: 'Enviar Certificado', icon: <RiMailSendLine size={16} />, action: () => enviarCertificado(ids) });

            acoes.push({ grupo: 'Carta Informativa', label: 'Visualizar E-mail Informativa', icon: <FaEye size={16} />, form: { method: 'post', action: urlVisualizar, data: { token: token, tipoCarta: "modeloemailinformativa", idParticipantes: ids, formato: "html" } } });
            acoes.push({ grupo: 'Carta Informativa', label: 'Visualizar Carta Informativa', icon: <FaEye size={16} />, form: { method: 'post', action: urlVisualizar, data: { token: token, tipoCarta: "modelocarta", idParticipantes: ids } } });
            acoes.push({ grupo: 'Carta Informativa', label: 'Enviar Informativa', icon: <RiMailSendLine size={16} />, action: () => enviarCartaInformativa(ids) });
        }
        if (perfisResetarEtapas.includes(perfil)) {
            acoes.push({ grupo: 'Etapas', label: 'Resetar Etapas', icon: <FaUndo size={16} />, action: () => abrirModalResetarEtapas(ids) });
        }
        if (perfisExcluir.includes(perfil)) {
            acoes.push({ grupo: 'Status', label: 'Excluir', icon: <ImCancelCircle size={16} />, danger: true, action: () => excluirParticipante(ids) });
        }
        return acoes;
    };

    const abrirAcoesParticipante = (row) => {
        setActionsModalData({ participante: row, actions: construirAcoesParticipante(row) });
        setShowActionsModal(true);
    };

    // ===== Seleção múltipla (multi-select) + ações em massa =====
    const idsPagina = participantesPagina.map((r) => String(r.id));
    const todosPaginaSelecionados = idsPagina.length > 0 && idsPagina.every((i) => selecionados.includes(i));

    const alternarSelecionado = (rowId) => {
        const idStr = String(rowId);
        setSelecionados((atual) => atual.includes(idStr) ? atual.filter((i) => i !== idStr) : [...atual, idStr]);
    };

    const alternarTodosPagina = () => {
        setSelecionados((atual) => {
            const jaTodos = idsPagina.length > 0 && idsPagina.every((i) => atual.includes(i));
            return jaTodos ? atual.filter((i) => !idsPagina.includes(i)) : Array.from(new Set([...atual, ...idsPagina]));
        });
    };

    // As ações em massa reaproveitam o MESMO drawer; o envio em massa é bloqueado para operadorrsvp
    // (esse perfil só envia individual — o backend também trava por quantidade > 1).
    const construirAcoesEmMassa = () => {
        const acoes = [];
        const ids = selecionados.join(',');
        const urlVisualizar = process.env.REACT_APP_API_URL + "/eventoCarta/visualizarCarta";
        const perfisVisualizar = ['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'operadorrsvp', 'gerentersvp', 'coordenadorrsvp'];
        const perfisEnviarMassa = ['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'];
        const perfisExcluir = ['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'];
        const perfisResetarEtapas = ['admin', 'gerentersvp', 'coordenadorrsvp'];

        if (perfisVisualizar.includes(perfil)) {
            acoes.push({ grupo: 'Carta Convite', label: 'Visualizar E-mail Convite', icon: <FaEye size={16} />, form: { method: 'post', action: urlVisualizar, data: { token: token, tipoCarta: "modeloemailconvite", idParticipantes: ids, formato: "html" } } });
            acoes.push({ grupo: 'Carta Convite', label: 'Visualizar Carta Convite', icon: <FaEye size={16} />, form: { method: 'post', action: urlVisualizar, data: { token: token, tipoCarta: "modelocartaconvite", idParticipantes: ids } } });
            acoes.push({ grupo: 'Certificado', label: 'Visualizar Certificado', icon: <FaEye size={16} />, form: { method: 'post', action: urlVisualizar, data: { token: token, tipoCarta: "modelocertificado", idParticipantes: ids } } });
            acoes.push({ grupo: 'Carta Informativa', label: 'Visualizar E-mail Informativa', icon: <FaEye size={16} />, form: { method: 'post', action: urlVisualizar, data: { token: token, tipoCarta: "modeloemailinformativa", idParticipantes: ids, formato: "html" } } });
            acoes.push({ grupo: 'Carta Informativa', label: 'Visualizar Carta Informativa', icon: <FaEye size={16} />, form: { method: 'post', action: urlVisualizar, data: { token: token, tipoCarta: "modelocarta", idParticipantes: ids } } });
        }
        if (perfisEnviarMassa.includes(perfil)) {
            acoes.push({ grupo: 'Carta Convite', label: 'Enviar Convite', icon: <RiMailSendLine size={16} />, action: () => enviarCartaConvite(ids) });
            acoes.push({ grupo: 'Certificado', label: 'Enviar Certificado', icon: <RiMailSendLine size={16} />, action: () => enviarCertificado(ids) });
            acoes.push({ grupo: 'Carta Informativa', label: 'Enviar Informativa', icon: <RiMailSendLine size={16} />, action: () => enviarCartaInformativa(ids) });
        }
        if (perfisResetarEtapas.includes(perfil)) {
            acoes.push({ grupo: 'Etapas', label: 'Resetar Etapas', icon: <FaUndo size={16} />, action: () => abrirModalResetarEtapas(ids) });
        }
        if (perfisExcluir.includes(perfil)) {
            acoes.push({ grupo: 'Status', label: 'Excluir selecionados', icon: <ImCancelCircle size={16} />, danger: true, action: () => excluirParticipante(ids) });
        }
        return acoes;
    };

    const abrirAcoesEmMassa = () => {
        setActionsModalData({ participante: null, emMassa: true, quantidade: selecionados.length, actions: construirAcoesEmMassa() });
        setShowActionsModal(true);
    };


    return (
        <ErpTemplate sidebar={['listarsvp'].includes(perfil) ? false : true}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">{evento.nome || 'Participantes'}</h1>
                        <p className="fin-pp__subtitle">Participantes do evento · gestão e envios</p>
                    </div>
                    <div className="fin-pp__actions">
                        {/* Como as cartas saem aos poucos, o operador precisa de um lugar para
                            ver o que ainda está na fila — sem isso ele clica em enviar de novo.
                            Mesmos perfis que podem disparar carta: quem não envia não tem o que
                            acompanhar, e a tela expõe erro de envio. */}
                        {['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link
                                to={`/cartaFila/${id}`}
                                className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <RiMailSendLine size={14} /> Fila de envio
                            </Link> : null}
                        {['listarsvp'].includes(perfil) ?
                            <Link to="/evento" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaBackward size={14} /> Eventos
                            </Link> : null}
                        {['listarsvp'].includes(perfil) ?
                            <Link
                                to={{
                                    pathname: "/cadastroEventoParticipanteLista",
                                    search: '?' + new URLSearchParams({ evento: id }).toString(),
                                    state: { evento: id }
                                }}
                                className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--primary">
                                <FaPlus size={14} /> Novo Participante
                            </Link> : null}
                        {['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link
                                to={{
                                    pathname: "/cadastroEventoParticipante",
                                    search: '?' + new URLSearchParams({ evento: id }).toString(),
                                    state: { evento: id }
                                }}
                                className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--primary">
                                <FaPlus size={14} /> Novo Participante
                            </Link> : null}
                        {['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link to={{ pathname: "/eventoImportarParticipante/" + id, state: { nomeEvento: evento.nome } }} className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaUpload size={14} /> Importar Participantes
                            </Link> : null}
                        {['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link to={{ pathname: "/eventoImportarAereo/" + id, state: { nomeEvento: evento.nome } }} className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaUpload size={14} /> Importar Aéreos Emitidos
                            </Link> : null}
                        {/* Solicitação de malha aérea: todo o time de RSVP (menos a Lista Digital) e
                            admin, o mesmo recorte do back (EventoAereoAprovacaoService::PERFIS_RSVP). */}
                        {['admin', 'rsvp', 'gerentersvp', 'coordenadorrsvp', 'operadorrsvp'].includes(perfil)
                            && permissoes.temAcesso('/cadastroEventoSolicitacoesAereo') ?
                            <Link to={{ pathname: "/cadastroEventoSolicitacoesAereo/" + id }} className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaPlane size={14} /> Solicitar Malha Aérea
                            </Link> : null}
                        {/* Solicitar Emissão de Aéreo: entrada ÚNICA daquela tela — só por aqui, no painel
                            de participantes. Gerente e coordenador de RSVP (e admin), o mesmo recorte do
                            back (EventoAereoEmissaoService::PERFIS_ENVIAR). */}
                        {['admin', 'gerentersvp', 'coordenadorrsvp'].includes(perfil)
                            && permissoes.temAcesso('/cadastroEventoEmissaoEnvioAereo') ?
                            <Link to={{ pathname: "/cadastroEventoEmissaoEnvioAereo/" + id }} className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaPlaneDeparture size={14} /> Solicitar Emissão de Aéreo
                            </Link> : null}
                        {['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link to={{ pathname: "/eventoImportarHospedagem/" + id, state: { nomeEvento: evento.nome } }} className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaUpload size={14} /> Importar Hospedagens
                            </Link> : null}
                        {['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link to={{ pathname: "/eventoImportarInscricoes/" + id, state: { nomeEvento: evento.nome } }} className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaUpload size={14} /> Importar Inscrições
                            </Link> : null}
                        {['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link to={{ pathname: "/eventoVincularParticipanteOperador/" + id, state: { nomeEvento: evento.nome } }} className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaUsers size={14} /> Vincular aos Operadores
                            </Link> : null}
                        {['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link to={{ pathname: "/eventoRelatorioParticipante/" + id }} className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaTable size={14} /> Relatório de Participantes
                            </Link> : null}
                        {['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link to={{ pathname: "/relatorioListaPresenca/" + id, state: { nomeEvento: evento.nome } }} className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaFileInvoice size={14} /> Lista de Presença
                            </Link> : null}
                        <form method="post" target="_blank" action={process.env.REACT_APP_API_URL + "/evento/exportarParticipanteAereo"} style={{ lineHeight: 0 }}>
                            <input type="hidden" name="data" value={JSON.stringify({ token: localStorage.getItem('token'), idEvento: id })} />
                            <button type="submit" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm"><FaTable size={14} /> Planilha Emissão Aérea</button>
                        </form>
                        <form method="post" target="_blank" action={process.env.REACT_APP_API_URL + "/evento/exportarParticipanteRoomingList"} style={{ lineHeight: 0 }}>
                            <input type="hidden" name="data" value={JSON.stringify({ token: localStorage.getItem('token'), idEvento: id })} />
                            <button type="submit" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm"><FaTable size={14} /> Planilha Rooming List</button>
                        </form>
                        {['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link to={{ pathname: "/cadastroEventoRsvp/" + id }} className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaPen size={14} /> Dados RSVP
                            </Link> : null}
                    </div>
                </div>

                {/* Só para quem envia carta: para os demais o card seria um aviso sobre uma
                    ação que eles não têm, e ele leva a uma tela com mensagem crua de erro. */}
                {PERFIS_FILA.includes(perfil) ? <CardCartaFila fila={fila} idEvento={id} /> : null}

                {['listarsvp'].includes(perfil) ? <ParticipantesConfirmados evento={id} datalista={filtro.datalista ?? ""} tipoListaPresenca={filtro.tipoListaPresenca ?? ""} /> : null}

                <form className="fin-pp__card" style={{ padding: '16px', marginTop: 16 }} onSubmit={(e) => { buscar(); e.preventDefault(); }}>
                    <div className="fin-pp__filters">
                        <div className="fin-pp__field fin-pp__field--auto" style={{ minWidth: 180 }}>
                            <label className="fin-pp__label">Data</label>
                            <ReactSelect
                                id="datalista"
                                value={{ value: filtro.datalista || null, label: filtro.nomeDatalista || null }}
                                onChange={(e) => {
                                    const newValue = e.value;
                                    const newLabel = e.label;

                                    // Salva no localStorage
                                    localStorage.setItem(`datalista_${id}`, newValue);
                                    localStorage.setItem(`nomeDatalista_${id}`, newLabel);

                                    // Atualiza o estado
                                    setFiltro({
                                        ...filtro,
                                        datalista: newValue,
                                        nomeDatalista: newLabel
                                    });
                                }}
                                loadOptions={(input) => {
                                    return api({
                                        method: 'get',
                                        action: '/evento/datas/' + id,
                                        token: token,
                                    })
                                        .then(response => {
                                            let options = response.data.data.map((registro) => {
                                                return {
                                                    value: registro,
                                                    label: registro
                                                };
                                            });
                                            return options;
                                        })
                                        .catch(function (error) {
                                            //console.log(error);
                                        });
                                }}
                            />
                        </div>
                        <div className="fin-pp__field fin-pp__field--auto" style={{ minWidth: 180 }}>
                            <label className="fin-pp__label">Tipo Listas</label>
                            <ReactSelect
                                id="tipoListaPresenca"
                                value={{ value: filtro.tipoListaPresenca || null, label: filtro.nomeTipoListaPresenca || null }}
                                onChange={(e) => {
                                    const newValue = e.value;
                                    const newLabel = e.label;

                                    // Salva no localStorage
                                    localStorage.setItem(`tipoListaPresenca_${id}`, newValue);
                                    localStorage.setItem(`nomeTipoListaPresenca_${id}`, newLabel);

                                    // Atualiza o estado
                                    setFiltro({
                                        ...filtro,
                                        tipoListaPresenca: newValue,
                                        nomeTipoListaPresenca: newLabel
                                    });
                                }}
                                loadOptions={(input) => {
                                    return api({
                                        method: 'get',
                                        action: '/participanteListaPresencaTipo',
                                        token: token,
                                        params: { nome: input }
                                    })
                                        .then(response => {
                                            let options = response.data.data.map((registro) => {
                                                const label = registro.nome;
                                                return {
                                                    value: registro.id,
                                                    label
                                                };
                                            });
                                            return options;
                                        })
                                        .catch(function (error) {
                                            //console.log(error);
                                        });
                                }}
                            />
                        </div>
                        <div className="fin-pp__field fin-pp__field--grow">
                            <label className="fin-pp__label">Nome do Participante</label>
                            <input autoFocus type="text" className="fin-pp__input" id="nome" placeholder="Buscar pelo nome do participante…"
                                value={filtro.nome ?? ""}
                                onChange={e => setFiltro({ ...filtro, ...{ "nome": e.target.value } })}
                            />
                        </div>
                        <div className="fin-pp__field fin-pp__field--auto">
                            <button type="submit" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--tall">
                                <FaSearch size={14} /> Buscar
                            </button>
                        </div>
                        {/* botão único: aparece para todos os perfis, e o modal é que decide quais
                            campos exibir (Cargo/Empresa só na lista digital de cliente não farmacêutico) */}
                        <div className="fin-pp__field fin-pp__field--auto">
                            <button
                                type="button"
                                className={`fin-pp__btn fin-pp__btn--tall${filtrosAplicados > 0 ? ' fin-pp__btn--primary' : ''}`}
                                onClick={abrirFiltros}
                            >
                                <FaFilter size={14} style={{ marginRight: 6 }} />
                                Filtros{filtrosAplicados > 0 ? ` (${filtrosAplicados})` : ''}
                            </button>
                        </div>
                    </div>
                </form>
                <section className="section" style={{ marginTop: 18 }}>
                    {!ehListaRsvp && contadoresStatus.length > 0 ?
                        <div style={{ marginBottom: 14 }}>
                            {/* a affordance do chip não é óbvia (ele nasceu como contador), então a
                                dica diz o que dá para fazer — e, com filtro ativo, como desfazer */}
                            <p className="fin-pp__cphead-sub" style={{ margin: '0 0 6px' }}>
                                {filtro.situacaoevento
                                    ? 'Filtrando por status — clique de novo para remover:'
                                    : 'Filtrar por status:'}
                            </p>
                            <div className="fin-pp__statusbar">
                            {contadoresStatus.map((situacao) => {
                                const ativo = String(filtro.situacaoevento ?? '') === String(situacao.id);
                                return (
                                    <button
                                        type="button"
                                        key={situacao.id}
                                        className="fin-pp__statuschip"
                                        aria-pressed={ativo}
                                        title={ativo ? 'Clique para remover o filtro' : 'Filtrar por ' + situacao.nome}
                                        onClick={() => filtrarPorStatus(situacao.id)}
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: (situacao.cor || '#8a8a8a') + (ativo ? '3d' : '1f'),
                                            color: situacao.cor || '#555',
                                            borderColor: (situacao.cor || '#8a8a8a') + (ativo ? 'ff' : '55'),
                                            fontWeight: ativo ? 700 : undefined,
                                        }}
                                    >
                                        <span className="fin-pp__statuschip-dot" style={{ backgroundColor: situacao.cor || '#8a8a8a' }} />
                                        <span className="fin-pp__statuschip-num">{situacao.quantidade}</span> {situacao.nome}
                                    </button>
                                );
                            })}
                            {filtro.situacaoevento ?
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--sm"
                                    onClick={limparFiltroStatus}
                                >
                                    <FaTimes size={12} /> Limpar status
                                </button> : null}
                            </div>
                        </div> : null}
                    <div className="fin-pp__cphead">
                        <span className="fin-pp__cphead-ic"><FaUsers size={18} /></span>
                        <div>
                            <h2 className="fin-pp__cphead-title">Participantes</h2>
                            <p className="fin-pp__cphead-sub">
                                {pagination.total} participante{pagination.total === 1 ? '' : 's'} nesta visão
                                {filtrosAplicados > 0 ? ' · ' + filtrosAplicados + ' filtro' + (filtrosAplicados === 1 ? '' : 's') + ' aplicado' + (filtrosAplicados === 1 ? '' : 's') : ''}
                            </p>
                        </div>
                    </div>
                    {selecionados.length > 0 && !['listarsvp', 'cliente'].includes(perfil) ?
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                            <span className="fin-pp__cell-strong">{selecionados.length} selecionado{selecionados.length === 1 ? '' : 's'}</span>
                            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 12 }}>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => setSelecionados([])}>Limpar seleção</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--sm" onClick={abrirAcoesEmMassa}>
                                    <FaEllipsisV size={14} /> Ações em massa
                                </button>
                            </div>
                        </div> : null}
                    <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                        {pagination.total > 0 ?
                            <div className="fin-pp__pagination">
                                <div className="fin-pp__pagination-info">
                                    {pagination.total} participante{pagination.total === 1 ? '' : 's'}
                                </div>
                                <div className="fin-pp__pagination-ctrls">
                                    <select className="fin-pp__select" style={{ height: 34 }} value={pagination.pageSize} onChange={(e) => carregarParticipantes({ page: 1, pageSize: Number(e.target.value), pedirTotais: false })}>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={200}>200</option>
                                    </select>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={pagination.page <= 1} onClick={() => carregarParticipantes({ page: pagination.page - 1, pedirTotais: false })}>Anterior</button>
                                    <span className="fin-pp__pagination-info">{pagination.page} / {totalPaginas}</span>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={pagination.page >= totalPaginas} onClick={() => carregarParticipantes({ page: pagination.page + 1, pedirTotais: false })}>Próxima</button>
                                </div>
                            </div> : null}
                        <div className="fin-pp__tblwrap" style={{ containerType: "inline-size" }}>
                            <table className="fin-pp__tbl" style={{ minWidth: ['listarsvp'].includes(perfil) ? 720 : 1000, tableLayout: 'auto' }}>
                                <thead>
                                    <tr>
                                        {!['listarsvp', 'cliente'].includes(perfil) ?
                                            <th style={{ width: 36 }}>
                                                <input type="checkbox" checked={todosPaginaSelecionados} onChange={alternarTodosPagina} title="Selecionar todos (página)" style={{ cursor: 'pointer' }} />
                                            </th> : null}
                                        {!['listarsvp', 'cliente'].includes(perfil) ? <th style={{ width: 48 }}></th> : null}
                                        <th style={{ width: 70 }}></th>
                                        {!['listarsvp'].includes(perfil) ? <th className="is-sortable" style={{ width: 120 }} onClick={() => ordenarPor('convite')}>Convite{ordem.campo === 'convite' ? (ordem.dir === 'asc' ? ' ▲' : ' ▼') : ''}</th> : null}
                                        {!['listarsvp'].includes(perfil) ? <th className="is-sortable" style={{ width: 120 }} onClick={() => ordenarPor('informativa')}>Informativa{ordem.campo === 'informativa' ? (ordem.dir === 'asc' ? ' ▲' : ' ▼') : ''}</th> : null}
                                        {!ehListaRsvp && vePresenca ? <th className="is-sortable" style={{ width: 130 }} onClick={() => ordenarPor('presenca')}>Lista de presença{ordem.campo === 'presenca' ? (ordem.dir === 'asc' ? ' ▲' : ' ▼') : ''}</th> : null}
                                        <th className="is-sortable" onClick={() => ordenarPor('nome')}>Nome{ordem.campo === 'nome' ? (ordem.dir === 'asc' ? ' ▲' : ' ▼') : ''}</th>
                                        {perfisColunaIdentificacao.includes(perfil) && mostrarColunaCrm ? <th style={{ width: 110 }}>CRM</th> : null}
                                        {/* em evento não farmacêutico, Instituição e Cargo ocupam o lugar do CRM */}
                                        {mostrarColunasNaoFarmaceutico ? <th style={{ width: 180 }}>Instituição</th> : null}
                                        {mostrarColunasNaoFarmaceutico ? <th style={{ width: 150 }}>Cargo</th> : null}
                                        {colunasNomeaveis.map((c, i) => <th key={'cn' + i} style={{ width: 120 }}>{c.name}</th>)}
                                        {!['listarsvp'].includes(perfil) ? <th style={{ width: 130 }}>Município</th> : null}
                                        {!['listarsvp'].includes(perfil) ? <th className="is-sortable" style={{ width: 180 }} onClick={() => ordenarPor('status')}>Status{ordem.campo === 'status' ? (ordem.dir === 'asc' ? ' ▲' : ' ▼') : ''}</th> : null}
                                        {!['listarsvp'].includes(perfil) ? <th style={{ width: 150 }}>Data</th> : null}
                                        {!['listarsvp'].includes(perfil) ? <th style={{ width: 120 }}>Operador</th> : null}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtro.buscando ?
                                        <tr><td colSpan={20} className="fin-pp__empty" style={{ padding: 0 }}><TabelaLoading /></td></tr>
                                        : participantesPagina.length === 0 ?
                                        <tr><td colSpan={20} className="fin-pp__empty" style={{ padding: 0 }}><TabelaVazia texto={ehListaRsvp && (filtro.nome ?? "") === "" && filtrosAplicados === 0 ? 'Busque para listar' : 'Nenhum registro'} /></td></tr>
                                        : participantesPagina.map((row) => {
                                            const acoesLinha = construirAcoesParticipante(row);
                                            const acaoAlterar = acoesLinha.find((a) => a.label === 'Alterar' && a.to);
                                            return (
                                                <tr key={row.id}>
                                                    {!['listarsvp', 'cliente'].includes(perfil) ?
                                                        <td>
                                                            <input type="checkbox" checked={selecionados.includes(String(row.id))} onChange={() => alternarSelecionado(row.id)} style={{ cursor: 'pointer' }} />
                                                        </td> : null}
                                                    {!['listarsvp', 'cliente'].includes(perfil) ?
                                                        <td>
                                                            {acaoAlterar ? <Link className="fin-pp__rowbtn" to={acaoAlterar.to} title="Alterar"><FaPen size={14} /></Link> : null}
                                                        </td> : null}
                                                    <td>
                                                        {['listarsvp'].includes(perfil) ?
                                                            (row.datalista?.imagemassinatura ?
                                                                <span className="fin-pp__rowbtn" title="Assinado" style={{ opacity: .65, cursor: 'default' }}>
                                                                    <FaCheck size={14} />
                                                                </span>
                                                                : <Link className="fin-pp__rowbtn" title="Assinar" to={linkAssinatura(row)}>
                                                                    <FaSignature size={16} />
                                                                </Link>)
                                                            : acoesLinha.length > 0 ?
                                                                <button type="button" className="fin-pp__rowbtn" title="Ações" onClick={() => abrirAcoesParticipante(row)}>
                                                                    <FaEllipsisV size={14} />
                                                                </button>
                                                                : <span className="text-muted">—</span>}
                                                    </td>
                                                    {!['listarsvp'].includes(perfil) ?
                                                        <td>
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                                                {row.datacartaconvite ? <span title={"Carta convite enviada em: " + dataHora(row.datacartaconvite)} className="fin-pp__minitag is-info">{dataHora(row.datacartaconvite)}</span> : null}
                                                                {row.datacartaassinada ? <span title={"Carta convite confirmada em: " + dataHora(row.datacartaassinada)} className="fin-pp__minitag is-ok">{dataHora(row.datacartaassinada)}</span> : null}
                                                                {row.imagemassinatura ? <span className="fin-pp__minitag is-info">Assinado</span> : null}
                                                            </div>
                                                        </td> : null}
                                                    {!['listarsvp'].includes(perfil) ?
                                                        <td>
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                                                {row.datacartainformativa ? <span title={"Carta informativa enviada em: " + dataHora(row.datacartainformativa)} className="fin-pp__minitag is-info">{dataHora(row.datacartainformativa)}</span> : null}
                                                                {row.dataconfirmacaocartainformativa ? <span title={"Carta informativa confirmada em: " + data(row.dataconfirmacaocartainformativa)} className="fin-pp__minitag is-ok">{data(row.dataconfirmacaocartainformativa)}</span> : null}
                                                                {row.datacertificado ? <span title={"Certificado enviado em: " + dataHora(row.datacertificado)} className="fin-pp__minitag is-info">{dataHora(row.datacertificado)}</span> : null}
                                                            </div>
                                                        </td> : null}
                                                    {!ehListaRsvp && vePresenca ?
                                                        <td>
                                                            {assinouLista(row)
                                                                ? <span className="fin-pp__minitag is-ok" title={'Assinou a lista de ' + (filtro.nomeDatalista ?? '')}>Assinado</span>
                                                                : <span className="fin-pp__cell-muted">—</span>}
                                                        </td> : null}
                                                    <td className="fin-pp__cell-strong">
                                                        {['listarsvp'].includes(perfil) ? row.nome : <span>{row.codigo}-{row.nome} - {row.cnpj}{row.cpf}</span>}
                                                        {fila.porParticipante[row.id] ?
                                                            <span style={{ marginLeft: 6 }}><BadgeCartaFila entradas={fila.porParticipante[row.id]} /></span>
                                                            : null}
                                                        {ehIncluidoNoLocal(row) ?
                                                            <span className="fin-pp__minitag is-warn" style={{ marginLeft: 6 }} title="Cadastrado durante o evento pela lista digital">Incluso no local</span>
                                                            : null}
                                                    </td>
                                                    {perfisColunaIdentificacao.includes(perfil) && mostrarColunaCrm ? <td className="fin-pp__cell-muted">{row.crm}</td> : null}
                                                    {mostrarColunasNaoFarmaceutico ? <td className="fin-pp__cell-muted">{row.instituicao ?? ''}</td> : null}
                                                    {mostrarColunasNaoFarmaceutico ? <td className="fin-pp__cell-muted">{(row.cargoparticipante?.nome ?? '') + (row.cargoespecificacao ? ' - ' + row.cargoespecificacao : '')}</td> : null}
                                                    {colunasNomeaveis.map((c, i) => <td key={'cnv' + i} className="fin-pp__cell-muted">{c.cell ? c.cell(row) : (c.selector ? c.selector(row) : '')}</td>)}
                                                    {!['listarsvp'].includes(perfil) ? <td className="fin-pp__cell-muted">{row.enderecomunicipio ? row.enderecomunicipio.nome + '-' + row.enderecomunicipio.uf : ''}</td> : null}
                                                    {!['listarsvp'].includes(perfil) ?
                                                        <td>
                                                            {row.situacaoevento ?
                                                                <span className="fin-pp__tag" style={{ backgroundColor: (row.situacaoevento.cor || '#8a8a8a') + '1f', color: row.situacaoevento.cor || '#555', borderColor: (row.situacaoevento.cor || '#8a8a8a') + '55' }}>{row.situacaoevento.nome}</span>
                                                                : ''}
                                                        </td> : null}
                                                    {!['listarsvp'].includes(perfil) ? <td className="fin-pp__cell-muted">{row.participantehistoricosituacao.length > 0 ? moment(row.participantehistoricosituacao[0].created_at).format("DD/MM/YYYY HH:mm:ss") : ''}</td> : null}
                                                    {!['listarsvp'].includes(perfil) ?
                                                        <td className="fin-pp__cell-muted">
                                                            {getNomeOperadorResponsavel(row)}
                                                            {getAtendimentoOperador(row) ?
                                                                <><br />
                                                                    <span
                                                                        className={"fin-pp__pill " + getEstiloAtendimento(getAtendimentoOperador(row))}
                                                                        title={row.eventooperador?.datareabertura
                                                                            ? "Atendimento reaberto em " + dataHora(row.eventooperador.datareabertura)
                                                                            : undefined}
                                                                    >
                                                                        {getAtendimentoOperador(row)}
                                                                    </span>
                                                                </>
                                                                : null}
                                                        </td> : null}
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>
                        {pagination.total > 0 ?
                            <div className="fin-pp__pagination">
                                <div className="fin-pp__pagination-info">
                                    {pagination.total} participante{pagination.total === 1 ? '' : 's'}
                                </div>
                                <div className="fin-pp__pagination-ctrls">
                                    <select className="fin-pp__select" style={{ height: 34 }} value={pagination.pageSize} onChange={(e) => carregarParticipantes({ page: 1, pageSize: Number(e.target.value), pedirTotais: false })}>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={200}>200</option>
                                    </select>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={pagination.page <= 1} onClick={() => carregarParticipantes({ page: pagination.page - 1, pedirTotais: false })}>Anterior</button>
                                    <span className="fin-pp__pagination-info">{pagination.page} / {totalPaginas}</span>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={pagination.page >= totalPaginas} onClick={() => carregarParticipantes({ page: pagination.page + 1, pedirTotais: false })}>Próxima</button>
                                </div>
                            </div> : null}
                    </div>
                </section>

                {showActionsModal && (
                    <div className="fin-pp fin-pp__drawer-backdrop" onClick={() => setShowActionsModal(false)}>
                        <div className="fin-pp__drawer" onClick={(e) => e.stopPropagation()}>
                            <div className="fin-pp__drawer-head">
                                <span className="fin-pp__drawer-head-ic"><FaEllipsisV size={16} /></span>
                                <div style={{ minWidth: 0, flex: 1 }}>
                                    <h3 className="fin-pp__drawer-title">{actionsModalData.emMassa ? 'Ações em massa' : 'Ações do participante'}</h3>
                                    <p className="fin-pp__drawer-sub">
                                        {actionsModalData.emMassa
                                            ? (actionsModalData.quantidade + ' participante' + (actionsModalData.quantidade === 1 ? '' : 's') + ' selecionado' + (actionsModalData.quantidade === 1 ? '' : 's'))
                                            : ((actionsModalData.participante?.codigo ? actionsModalData.participante.codigo + ' — ' : '') + (actionsModalData.participante?.nome || 'Participante'))}
                                    </p>
                                </div>
                                <button type="button" className="fin-pp__drawer-close" onClick={() => setShowActionsModal(false)}><FaTimes size={16} /></button>
                            </div>
                            <div className="fin-pp__drawer-body">
                                {(() => {
                                    const ordemGrupos = ['Cadastro', 'Carta Convite', 'Certificado', 'Carta Informativa', 'Etapas', 'Status'];
                                    const renderItem = (action, key) => {
                                        const inner = (
                                            <>
                                                <span className="fin-pp__drawer-item-ic">{action.icon}</span>
                                                <span className="fin-pp__drawer-item-label">{action.label}</span>
                                            </>
                                        );
                                        if (action.disabled) {
                                            return <div key={key} className="fin-pp__drawer-item" style={{ opacity: .65, cursor: 'default' }}>{inner}</div>;
                                        }
                                        if (action.to) {
                                            return <Link key={key} className="fin-pp__drawer-item" to={action.to} onClick={() => setShowActionsModal(false)}>{inner}</Link>;
                                        }
                                        if (action.form) {
                                            return (
                                                <form key={key} method={action.form.method} target="_blank" action={action.form.action} style={{ margin: 0 }}>
                                                    {action.form.data ? <input type="hidden" name="data" value={JSON.stringify(action.form.data)} /> : null}
                                                    <button type="submit" className="fin-pp__drawer-item" style={{ width: '100%' }}>{inner}</button>
                                                </form>
                                            );
                                        }
                                        return <button key={key} type="button" className="fin-pp__drawer-item" onClick={(e) => { e.stopPropagation(); action.action(); setShowActionsModal(false); }}>{inner}</button>;
                                    };
                                    const usados = new Set();
                                    const secoes = ordemGrupos.map(g => {
                                        const itens = actionsModalData.actions.filter(a => a.grupo === g);
                                        itens.forEach(a => usados.add(a));
                                        return { titulo: g, itens };
                                    }).filter(s => s.itens.length > 0);
                                    const outras = actionsModalData.actions.filter(a => !usados.has(a));
                                    if (outras.length) secoes.push({ titulo: 'Outras ações', itens: outras });
                                    if (secoes.length === 0) return <div className="fin-pp__empty">Nenhuma ação disponível</div>;
                                    return secoes.map((s, si) => (
                                        <div key={si}>
                                            <div className="fin-pp__drawer-section">{s.titulo}</div>
                                            {s.itens.map((a, i) => renderItem(a, si + '-' + i))}
                                        </div>
                                    ));
                                })()}
                            </div>
                        </div>
                    </div>
                )}

                {showResetarEtapasModal && (
                    <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                        onClick={(e) => { if (e.target === e.currentTarget && !resetarEtapasSubmitting) setShowResetarEtapasModal(false); }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content fin-pp__modal">
                                <div className="fin-pp__modal-head">
                                    <span className="fin-pp__modal-head-ic is-danger"><FaUndo size={17} /></span>
                                    <h3 className="fin-pp__modal-title">Resetar Etapas
                                        <span className="fin-pp__modal-sub">
                                            {(() => {
                                                const qtd = resetarEtapasIds.split(',').filter(Boolean).length;
                                                return qtd + ' participante' + (qtd === 1 ? '' : 's');
                                            })()}
                                        </span>
                                    </h3>
                                    <button type="button" className="fin-pp__modal-close" disabled={resetarEtapasSubmitting} onClick={() => setShowResetarEtapasModal(false)}><FaTimes size={16} /></button>
                                </div>
                                <div className="modal-body">
                                    <p className="fin-pp__cell-muted" style={{ marginBottom: 14 }}>
                                        Marque as etapas que deseja reabrir. A data de conclusão será apagada e o participante voltará a passar por elas.
                                        Ligue <strong>Apagar dados</strong> para também zerar o que ele respondeu na tela da etapa.
                                    </p>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                        {ETAPAS_RESET.map((etapa) => (
                                            <div key={etapa.key}>
                                                <label className="form-check" style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', margin: 0 }}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        style={{ margin: 0, cursor: 'pointer' }}
                                                        checked={!!resetarEtapasSelecao[etapa.key]}
                                                        onChange={(e) => {
                                                            const marcada = e.target.checked;
                                                            setResetarEtapasSelecao((atual) => ({ ...atual, [etapa.key]: marcada }));
                                                            // desmarcou a etapa: o "Apagar dados" dela deixa de valer (o switch some)
                                                            if (!marcada) { setResetarEtapasApagarDados((atual) => ({ ...atual, [etapa.key]: false })); }
                                                        }}
                                                    />
                                                    <span className="form-check-label">{etapa.label}</span>
                                                </label>
                                                {!!resetarEtapasSelecao[etapa.key] && (
                                                    <label className="form-check form-switch" style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', margin: '6px 0 0 26px' }}>
                                                        <input
                                                            type="checkbox"
                                                            role="switch"
                                                            className="form-check-input"
                                                            style={{ margin: 0, cursor: 'pointer' }}
                                                            checked={!!resetarEtapasApagarDados[etapa.key]}
                                                            onChange={(e) => setResetarEtapasApagarDados((atual) => ({ ...atual, [etapa.key]: e.target.checked }))}
                                                        />
                                                        <span className="form-check-label fin-pp__cell-muted">Apagar dados</span>
                                                    </label>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="fin-pp__modal-foot">
                                    <button type="button" className="fin-pp__btn" disabled={resetarEtapasSubmitting} onClick={() => setShowResetarEtapasModal(false)}>Cancelar</button>
                                    <button
                                        type="button"
                                        className="fin-pp__btn fin-pp__btn--danger"
                                        disabled={resetarEtapasSubmitting || !ETAPAS_RESET.some((e) => resetarEtapasSelecao[e.key])}
                                        onClick={confirmarResetarEtapas}
                                    >
                                        {resetarEtapasSubmitting ? 'Resetando…' : 'Resetar'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {mostrarFiltros && (
                    <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                        onClick={(e) => { if (e.target === e.currentTarget) setMostrarFiltros(false); }}>
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                            <div className="modal-content fin-pp__modal">
                                <div className="fin-pp__modal-head">
                                    <span className="fin-pp__modal-head-ic"><FaFilter size={17} /></span>
                                    <h3 className="fin-pp__modal-title">Filtros
                                        <span className="fin-pp__modal-sub">Refine a lista de participantes</span>
                                    </h3>
                                    <button type="button" className="fin-pp__modal-close" onClick={() => setMostrarFiltros(false)}><FaTimes size={16} /></button>
                                </div>
                                <div className="modal-body">
                                    <div className="fin-pp__filters" style={{ alignItems: 'stretch' }}>
                                        {/* Cargo e Instituição: só na lista digital de evento com o ramo não farmacêutico */}
                                        {temFiltrosNaoFarmaceutico ?
                                            <FinField label="Cargo" full>
                                                <ReactSelect
                                                    id="filtroCargoparticipante"
                                                    isClearable
                                                    value={filtrosRascunho.cargoparticipante ? { value: filtrosRascunho.cargoparticipante, label: filtrosRascunho.nomeCargoparticipante } : null}
                                                    onChange={e => setFiltrosRascunho({
                                                        ...filtrosRascunho,
                                                        cargoparticipante: e ? e.value : '',
                                                        nomeCargoparticipante: e ? e.label : '',
                                                    })}
                                                    loadOptions={(input) => {
                                                        return api({
                                                            method: 'get',
                                                            action: '/participanteCargo',
                                                            token: token,
                                                            params: { nome: input, categoria: CATEGORIA_NAO_FARMACEUTICO }
                                                        })
                                                            .then(response => response.data.data.map(registro => ({ value: registro.id, label: registro.nome })))
                                                            .catch(function (error) {
                                                                //console.log(error);
                                                            });
                                                    }}
                                                />
                                            </FinField> : null}
                                        {temFiltrosNaoFarmaceutico ?
                                            <FinField label="Instituição" full>
                                                <FinInput
                                                    id="filtroInstituicao"
                                                    value={filtrosRascunho.instituicao ?? ''}
                                                    placeholder="Buscar pela instituição…"
                                                    onChange={e => setFiltrosRascunho({ ...filtrosRascunho, instituicao: e.target.value })}
                                                    style={{ paddingLeft: 14 }}
                                                />
                                            </FinField> : null}
                                        {vePresenca ?
                                            <div className="fin-pp__field fin-pp__field--half">
                                                <label className="fin-pp__label">Origem do cadastro</label>
                                                <ReactSelect
                                                    id="origem"
                                                    value={OPCOES_ORIGEM.find((o) => o.value === (filtrosRascunho.origem ?? 'todos'))}
                                                    onChange={(e) => setFiltrosRascunho({ ...filtrosRascunho, origem: e.value })}
                                                    options={OPCOES_ORIGEM}
                                                />
                                            </div> : null}
                                        {vePresenca ?
                                            <div className="fin-pp__field fin-pp__field--half">
                                                <label className="fin-pp__label">Lista de presença</label>
                                                <ReactSelect
                                                    id="assinado"
                                                    value={OPCOES_ASSINADO.find((o) => o.value === (filtrosRascunho.assinado ?? 'todos'))}
                                                    onChange={(e) => setFiltrosRascunho({ ...filtrosRascunho, assinado: e.value })}
                                                    options={OPCOES_ASSINADO}
                                                />
                                            </div> : null}
                                        {!ehListaRsvp ?
                                            <div className="fin-pp__field fin-pp__field--half">
                                                <label className="fin-pp__label">Carta Convite</label>
                                                <ReactSelect
                                                    value={{ value: filtrosRascunho.situacaocartaconvite ?? '', label: filtrosRascunho.nomeSituacaocartaconvite ?? 'Todas' }}
                                                    onChange={(e) => setFiltrosRascunho({ ...filtrosRascunho, situacaocartaconvite: e.value, nomeSituacaocartaconvite: e.label })}
                                                    options={[
                                                        { value: '', label: 'Todas' },
                                                        { value: 'confirmada', label: 'Confirmada' },
                                                        { value: 'naoconfirmada', label: 'Não Confirmada' },
                                                    ]}
                                                />
                                            </div> : null}
                                        {!ehListaRsvp ?
                                            <div className="fin-pp__field fin-pp__field--half">
                                                <label className="fin-pp__label">Carta Informativa</label>
                                                <ReactSelect
                                                    value={{ value: filtrosRascunho.situacaocartainformativa ?? '', label: filtrosRascunho.nomeSituacaocartainformativa ?? 'Todas' }}
                                                    onChange={(e) => setFiltrosRascunho({ ...filtrosRascunho, situacaocartainformativa: e.value, nomeSituacaocartainformativa: e.label })}
                                                    options={[
                                                        { value: '', label: 'Todas' },
                                                        { value: 'confirmada', label: 'Confirmada' },
                                                        { value: 'naoconfirmada', label: 'Não Confirmada' },
                                                    ]}
                                                />
                                            </div> : null}
                                    </div>
                                    {vePresenca ?
                                        <p className="fin-pp__cell-muted" style={{ marginTop: 12, marginBottom: 0 }}>
                                            O filtro de lista de presença considera o dia selecionado{filtro.nomeDatalista ? ' (' + filtro.nomeDatalista + ')' : ''}.
                                        </p> : null}
                                </div>
                                <div className="fin-pp__modal-foot">
                                    <button
                                        type="button"
                                        className="fin-pp__btn"
                                        onClick={() => setFiltrosRascunho({
                                            cargoparticipante: '',
                                            nomeCargoparticipante: '',
                                            instituicao: '',
                                            origem: 'todos',
                                            assinado: 'todos',
                                            situacaocartaconvite: '',
                                            nomeSituacaocartaconvite: 'Todas',
                                            situacaocartainformativa: '',
                                            nomeSituacaocartainformativa: 'Todas',
                                            // `situacaoevento` NÃO entra aqui: ele é aplicado no clique do
                                            // contador, não pelo "Aplicar filtros", e tem o "Limpar status"
                                            // dedicado ao lado dos chips.
                                        })}
                                    >
                                        Limpar filtros
                                    </button>
                                    <button
                                        type="button"
                                        className="fin-pp__btn fin-pp__btn--primary"
                                        onClick={aplicarFiltros}
                                    >
                                        <FaSearch size={14} /> Aplicar filtros
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showDiaListaModal && (
                    <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                        onClick={(e) => { if (e.target === e.currentTarget) setShowDiaListaModal(false); }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content fin-pp__modal">
                                <div className="fin-pp__modal-head">
                                    <span className="fin-pp__modal-head-ic"><FaCalendarAlt size={17} /></span>
                                    <h3 className="fin-pp__modal-title">Dia da lista
                                        <span className="fin-pp__modal-sub">{evento.nome || 'Evento'}</span>
                                    </h3>
                                    <button type="button" className="fin-pp__modal-close" onClick={() => setShowDiaListaModal(false)}><FaTimes size={16} /></button>
                                </div>
                                <div className="modal-body">
                                    <p className="fin-pp__cell-muted" style={{ marginBottom: 14 }}>
                                        Hoje ({moment().format('DD/MM/YYYY')}) não é um dos dias deste evento.
                                        Escolha o dia da lista de presença que você vai preencher.
                                    </p>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                        {diasEvento.map((dia) => (
                                            <button
                                                key={dia}
                                                type="button"
                                                className={"fin-pp__btn" + (filtro.datalista === dia ? " fin-pp__btn--primary" : "")}
                                                onClick={() => { aplicarDataLista(dia); setShowDiaListaModal(false); }}
                                            >
                                                {dia}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div className="fin-pp__modal-foot">
                                    <button type="button" className="fin-pp__btn" onClick={() => setShowDiaListaModal(false)}>
                                        Manter {filtro.datalista || 'o dia atual'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div >

            <ModalForcarEnvio
                show={forcarEnvio.show}
                mensagem={forcarEnvio.mensagem}
                onFechar={() => setForcarEnvio({ show: false, mensagem: '', reenviar: null })}
                onConfirmar={() => {
                    // `reenviar` ja carrega os ids e o forcar: e closure, como nas telas de
                    // cadastro. Guardar os ids no estado do modal separava o alvo da acao e o
                    // deixava sem dono — foi assim que um `ids` removido virou envio sem alvo.
                    const reenviar = forcarEnvio.reenviar;
                    setForcarEnvio({ show: false, mensagem: '', reenviar: null });
                    if (reenviar) reenviar();
                }}
            />
        </ErpTemplate >
    );
}
